(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[41781,65250],{

/***/ 41781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BestRoundupLawyersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
;// CONCATENATED MODULE: ./src/components/bestrounduplawyers/logo/index.tsx


function BestZantaclawyersLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "391",
        height: "43",
        fill: "none",
        viewBox: "0 0 391 43",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#0A6938",
                clipPath: "url(#clip0_0_32)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M54.441 11.007h9.6c2.353 0 4.122.42 5.308 1.26a4.28 4.28 0 011.78 3.754 4.531 4.531 0 01-1.156 3.162 6.812 6.812 0 01-3.4 1.864 6.385 6.385 0 014.28 1.407 4.746 4.746 0 011.535 3.742 5.539 5.539 0 01-2.079 4.648c-1.382 1.076-3.375 1.614-5.98 1.614h-9.882V30.91l1.89-.171.513-.496V13.178l-.513-.453-1.89-.153-.006-1.565zm6.573 9.527h.857c1.669 0 2.892-.336 3.669-1.01.776-.672 1.174-1.717 1.174-3.142a3.407 3.407 0 00-1.089-2.782c-.728-.612-1.834-.905-3.357-.905-.25 0-.648 0-1.186.06h-.098l.03 7.779zm0 10.114h.11c.649.03 1.126.043 1.438.043 1.879 0 3.243-.34 4.09-1.021.856-.685 1.278-1.78 1.278-3.296a3.769 3.769 0 00-1.223-3.058c-.815-.672-2.017-1.009-3.607-1.009h-1.168l-.942.043.024 8.298zM89.351 28.495v2.373a15.018 15.018 0 01-3.314 1.406 12.394 12.394 0 01-3.345.465 7.692 7.692 0 01-5.742-2.201 7.949 7.949 0 01-2.165-5.822 8.236 8.236 0 012.196-5.943 7.552 7.552 0 015.699-2.3c2.103 0 3.742.612 4.891 1.896 1.15 1.284 1.755 3.058 1.755 5.332v.612h-10.45v.092a6.262 6.262 0 001.376 4.28 4.78 4.78 0 003.779 1.56 8.25 8.25 0 002.58-.435c.961-.33 1.88-.772 2.74-1.315zm-4.22-5.888v-.343a5.24 5.24 0 00-.715-2.99 2.36 2.36 0 00-2.06-1.04 2.832 2.832 0 00-2.36 1.169 5.503 5.503 0 00-.967 3.204h6.103zM102.975 17.268v4.281h-1.92l-.312-2.403-.385-.361a5.687 5.687 0 00-1.064-.373 4.437 4.437 0 00-1.046-.122 2.843 2.843 0 00-1.798.501 1.712 1.712 0 00-.611 1.419c-.01.478.168.941.495 1.29a9.54 9.54 0 002.483 1.517h.061c3.07 1.48 4.607 2.984 4.611 4.512a4.717 4.717 0 01-1.743 3.865c-1.162.942-2.758 1.412-4.788 1.412a16.508 16.508 0 01-2.501-.201 24.114 24.114 0 01-2.776-.612v-4.727h1.926l.373 2.746.324.36c.411.216.846.382 1.296.496.456.117.924.174 1.395.171a2.984 2.984 0 001.987-.611 2.115 2.115 0 00.728-1.694c0-.905-.924-1.78-2.764-2.611-.612-.281-1.107-.508-1.456-.685a8.598 8.598 0 01-2.782-1.944 3.412 3.412 0 01-.807-2.27 4.134 4.134 0 011.712-3.454 7.294 7.294 0 014.562-1.309c.819 0 1.637.065 2.446.196.8.14 1.587.344 2.354.611zM107.317 19.22h-2.073v-1.224l2.354-1.339 1.669-3.327h2.018v3.975h4.727v1.92h-4.727v7.95c0 1.223.19 2.017.575 2.445a2.676 2.676 0 002.079.661c.368.001.735-.017 1.101-.055.327-.035.652-.09.972-.165v1.522c-.852.312-1.724.564-2.611.753-.748.162-1.51.248-2.275.256a6.072 6.072 0 01-1.492-.17 3.739 3.739 0 01-1.162-.533c-.4-.25-.714-.617-.899-1.052a7.113 7.113 0 01-.256-2.335v-9.283zM122.524 11.007h9.729c2.446 0 4.323.465 5.595 1.394a4.7 4.7 0 011.914 4.073 4.844 4.844 0 01-1.388 3.583 7.668 7.668 0 01-4.109 1.877 7.34 7.34 0 012.006.758c.534.304.995.722 1.351 1.223a12.18 12.18 0 011.345 3.18c.214.703.386 1.223.514 1.547.223.71.674 1.328 1.284 1.755a4.89 4.89 0 002.495.495h.404v1.53c-.612.085-1.156.146-1.694.189a18.98 18.98 0 01-1.505.06 6.494 6.494 0 01-1.834-.256 4.496 4.496 0 01-1.474-.728 7.368 7.368 0 01-2.281-3.7l-.171-.562c-.607-1.822-1.257-3.01-1.95-3.565a4.895 4.895 0 00-3.107-.837h-.544v7.197l.514.501 1.95.171v1.56h-9.025v-1.56l1.889-.17.52-.502V13.178l-.52-.453-1.889-.153-.019-1.565zm6.562 1.834v8.335h1.143c1.724 0 3.002-.355 3.822-1.052.431-.413.765-.917.977-1.476a4.025 4.025 0 00.246-1.753 3.816 3.816 0 00-1.223-3.057 5.26 5.26 0 00-3.516-1.046l-1.449.05zM151.313 16.504c2.446 0 4.397.742 5.852 2.226 1.456 1.484 2.179 3.49 2.171 6.017a7.667 7.667 0 01-2.262 5.779 8.296 8.296 0 01-6.011 2.183 7.86 7.86 0 01-5.816-2.208 7.854 7.854 0 01-2.207-5.815 7.991 7.991 0 012.262-5.944 8.186 8.186 0 016.011-2.238zm-.122 1.7a3.06 3.06 0 00-2.733 1.67 9.315 9.315 0 00-.985 4.684 9.575 9.575 0 00.979 4.763 2.985 2.985 0 002.708 1.7 3.099 3.099 0 002.795-1.651c.656-1.109.982-2.68.978-4.715a9.474 9.474 0 00-.99-4.745 3.055 3.055 0 00-2.752-1.706zM165.549 16.504h1.535v9.912c0 1.272.232 2.183.709 2.74a2.894 2.894 0 002.33.838c.41-.005.819-.044 1.223-.117.52-.099 1.035-.227 1.541-.385V19.28h-2.079v-1.278l4.543-1.498h1.468v13.912l.434.483 1.675.122v1.437h-6.041v-1.761a15.47 15.47 0 01-2.948 1.565 6.887 6.887 0 01-2.446.477 4.013 4.013 0 01-3.302-1.339c-.721-.899-1.082-2.269-1.082-4.121V19.28h-2.079v-1.278l4.519-1.498zM180.475 32.458V31.02l1.639-.122.453-.483V19.409h-2.183v-1.284l4.604-1.499h1.547v1.89a21.853 21.853 0 013.149-1.48 7.142 7.142 0 012.312-.47 3.993 3.993 0 013.265 1.314c.716.874 1.076 2.201 1.076 3.993v8.56l.422.484 1.682.122v1.437h-7.821V31.04l1.376-.122.44-.483v-7.668a4.084 4.084 0 00-.691-2.617 2.663 2.663 0 00-2.183-.832 7.014 7.014 0 00-1.333.14 17.91 17.91 0 00-1.694.404v10.555l.434.483 1.407.122v1.437h-7.901zM211.276 11.618h-2.342V10.34l4.763-1.498h1.48v21.574l.441.513 1.638.123v1.406h-5.98v-1.792c-.828.63-1.73 1.158-2.684 1.572a6.179 6.179 0 01-2.373.501 5.505 5.505 0 01-4.458-2.146 8.523 8.523 0 01-1.743-5.546 8.571 8.571 0 012.318-6.2 7.908 7.908 0 015.956-2.373c.48 0 .96.026 1.437.08.501.048 1.027.128 1.578.231l-.031-5.167zm0 17.795V18.736a11.335 11.335 0 00-1.296-.349 5.354 5.354 0 00-1.077-.116 4.004 4.004 0 00-3.351 1.651 7.193 7.193 0 00-1.253 4.452 6.73 6.73 0 001.137 4.152 3.744 3.744 0 003.156 1.498 5.544 5.544 0 001.192-.147c.508-.119 1.006-.274 1.492-.464zM224.643 11.007h9.173v1.565l-1.982.153-.452.453v11.196c0 2.136.407 3.66 1.223 4.574.813.917 2.14 1.37 3.993 1.37 1.712 0 2.949-.485 3.712-1.456.762-.97 1.143-2.566 1.143-4.788V13.306l-.483-.55-2.042-.184v-1.565h7.258v1.565l-1.951.184-.44.55v11.099c0 2.967-.664 5.116-1.993 6.445-1.329 1.329-3.478 1.995-6.446 2a11.268 11.268 0 01-4.078-.68 6.307 6.307 0 01-2.758-1.944 6.113 6.113 0 01-1.082-2.287 16.083 16.083 0 01-.324-3.669V13.202l-.453-.452-2.012-.153-.006-1.59zM247.281 39.466v-1.48l1.73-.16.434-.482V19.378h-2.164v-1.284l4.635-1.498h1.437v1.932A14.126 14.126 0 01256.086 17a6.227 6.227 0 012.324-.483 5.319 5.319 0 014.323 2.135 8.346 8.346 0 011.718 5.405c0 2.564-.764 4.602-2.293 6.115-1.535 1.529-3.589 2.287-6.182 2.287-.44 0-.874 0-1.309-.037-.434-.036-.862-.067-1.302-.116v5.1l.483.459 1.981.122v1.48h-8.548zm6.072-8.928c.337.072.678.127 1.021.165.339.037.68.055 1.021.055a4.095 4.095 0 003.431-1.67 7.266 7.266 0 001.271-4.5 6.163 6.163 0 00-1.119-3.926 3.727 3.727 0 00-3.1-1.412 4.617 4.617 0 00-1.131.153c-.475.119-.941.272-1.394.458v10.677zM271.123 32.458v-1.56l1.95-.17.544-.502V13.178l-.452-.453-2.042-.153v-1.565h9.209v1.565l-1.951.153-.514.453v17.421h6.152l.404-.514.483-3.889h2.372v6.262h-16.155zM299.172 30.63a14.08 14.08 0 01-2.948 1.608c-.81.32-1.672.49-2.544.501a4.088 4.088 0 01-3.014-1.162 4.017 4.017 0 01-1.168-2.99 4.004 4.004 0 011.712-3.467c1.15-.815 3.82-1.694 8.011-2.636v-.953a3.67 3.67 0 00-.734-2.532 3.026 3.026 0 00-2.312-.795 5.915 5.915 0 00-.715.049c-.251 0-.52.08-.813.14v2.997h-2.948a1.766 1.766 0 01-1.119-.281 1.07 1.07 0 01-.348-.887c0-1.003.666-1.871 2.011-2.611a10.093 10.093 0 014.941-1.107c2.194 0 3.737.422 4.629 1.266.893.844 1.339 2.311 1.339 4.403v8.273l.422.453 1.706.152v1.407h-5.686l-.422-1.828zm0-1.31v-5.215c-2.1.473-3.527.982-4.281 1.529a2.631 2.631 0 00-1.155 2.25 2.363 2.363 0 00.611 1.755 2.308 2.308 0 001.731.648c.469-.01.935-.091 1.382-.238a11.12 11.12 0 001.712-.728zM305.574 16.895h7.949v1.468l-1.559.22-.361.453 2.593 9.209 3.73-11.35h3.198l3.498 11.35 2.813-9.246-.233-.452-1.687-.184v-1.468h6.041v1.468l-1.798.22-4.341 13.875h-3.229l-3.546-11.472-3.792 11.472h-3.204l-4.134-13.93-1.92-.183-.018-1.45z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M331.024 16.926h8.115v1.376l-1.621.183-.33.453 3.449 9.038 3.479-9.008-.275-.483-1.688-.183v-1.376h6.115v1.376l-1.73.281-6.17 15a12.849 12.849 0 01-2.734 4.317 4.613 4.613 0 01-3.21 1.566 2.817 2.817 0 01-1.938-.71 2.158 2.158 0 01-.814-1.663 2.11 2.11 0 01.434-1.272 3.369 3.369 0 011.223-.99l2.777 1.907a5.98 5.98 0 001.29-1.51c.475-.757.884-1.552 1.223-2.379l-5.687-14.266-1.914-.281.006-1.376zM363.366 28.495v2.373a14.904 14.904 0 01-3.314 1.406c-1.087.308-2.21.464-3.339.465a7.694 7.694 0 01-5.748-2.201 7.955 7.955 0 01-2.165-5.821 8.238 8.238 0 012.214-5.944 7.553 7.553 0 015.699-2.3c2.103 0 3.734.632 4.892 1.896 1.158 1.264 1.741 3.041 1.749 5.332v.612h-10.475v.092a6.261 6.261 0 001.376 4.28 4.776 4.776 0 003.785 1.56 8.242 8.242 0 002.58-.435c.964-.329 1.885-.77 2.746-1.315zm-4.213-5.888v-.343a5.24 5.24 0 00-.716-2.99 2.363 2.363 0 00-2.06-1.04 2.836 2.836 0 00-2.361 1.169 5.505 5.505 0 00-.966 3.204h6.103zM365.286 32.458V31.02l1.706-.122.452-.483V19.409h-2.311v-1.284l4.696-1.499h1.547l-.14 3.266c.55-.612 1.137-1.15 1.761-1.694a25.884 25.884 0 011.969-1.553c.141-.028.284-.048.428-.061h.293c.349 0 .697.045 1.034.134.371.096.73.233 1.07.41l-.404 4.42h-1.669a2.447 2.447 0 00-.868-.873 2.448 2.448 0 00-1.223-.282c-.336.014-.666.09-.973.226-.448.185-.88.408-1.29.667v9.172l.471.483 2.275.123V32.5l-8.824-.043zM390.455 17.268v4.28h-1.92l-.306-2.408-.391-.361a5.683 5.683 0 00-1.064-.373 4.439 4.439 0 00-1.046-.122 2.814 2.814 0 00-1.792.501 1.707 1.707 0 00-.611 1.419c-.008.479.172.942.501 1.29a9.356 9.356 0 002.477 1.516h.067c3.07 1.48 4.605 2.984 4.605 4.513a4.702 4.702 0 01-1.743 3.865c-1.162.942-2.752 1.412-4.782 1.412a16.578 16.578 0 01-2.507-.201 23.738 23.738 0 01-2.77-.612V27.26h1.92l.373 2.746.33.36c.411.217.846.383 1.297.496.453.116.92.173 1.388.171a2.972 2.972 0 001.987-.611 2.12 2.12 0 00.728-1.694c0-.905-.924-1.78-2.764-2.611-.612-.282-1.107-.508-1.45-.685a8.713 8.713 0 01-2.788-1.945 3.406 3.406 0 01-.801-2.268 4.154 4.154 0 011.706-3.455 7.302 7.302 0 014.568-1.309c.819 0 1.637.066 2.446.196.796.142 1.579.349 2.342.617zM0 29.046h41.66c-.164.403-.342.807-.531 1.223h-7.49c.31.33.653.685 1.02 1.045 1.036.243 2.086.42 3.143.532.813.086 1.63.12 2.446.104-.238.41-.489.808-.752 1.223-.587 0-1.186-.036-1.798-.11-.464-.049-.93-.11-1.4-.19.66.612 1.376 1.224 2.122 1.762-.25.312-.508.611-.777.91a35.926 35.926 0 01-2.568-2.164 54.216 54.216 0 01-3.057-3.088H28.03a14.675 14.675 0 003.155 3.901 16.968 16.968 0 004.837 2.99c-.324.3-.66.612-1.003.869a18.637 18.637 0 01-3.35-1.932c.036.318.09.672.17 1.051.187.886.438 1.757.752 2.605-.342.208-.69.416-1.045.612a19.688 19.688 0 01-.88-2.978 12.375 12.375 0 01-.258-2.3 15.772 15.772 0 01-3.705-4.8h-3.565c-.122.96-.263 2.318-.324 3.939.448.617.958 1.186 1.522 1.7a6.598 6.598 0 001.7 1.13 6.071 6.071 0 012.33 2.129c.458.679.867 1.39 1.223 2.128-.367.159-.746.3-1.119.44a15.424 15.424 0 00-1.113-1.883 5.008 5.008 0 00-1.834-1.725 7.888 7.888 0 01-2.006-1.327 10.979 10.979 0 01-.758-.746c.001 2.303.193 4.602.574 6.873-.397.043-.794.08-1.223.104a42.918 42.918 0 01-.568-7.588c-.38.477-.783.966-1.186 1.443a32.25 32.25 0 01-2.281 2.446 3.23 3.23 0 00-.844 1.565 7.579 7.579 0 00-.196 1.835 35.273 35.273 0 01-1.223-.233 8.8 8.8 0 01.232-1.907 4.36 4.36 0 011.187-2.153c.8-.759 1.557-1.56 2.268-2.403a44.948 44.948 0 002.159-2.733c.067-1.223.171-2.3.275-3.1h-4.152a20.093 20.093 0 01-2.703 6.726c-.244.373-.501.74-.789 1.1.24.662.377 1.358.404 2.061.037.688.01 1.378-.08 2.06-.39-.11-.776-.231-1.161-.366.06-.54.076-1.084.049-1.627-.02-.35-.065-.7-.135-1.045a14.066 14.066 0 01-2.067 1.791 25.388 25.388 0 01-1.223-.611 13.214 13.214 0 004-4.012 18.712 18.712 0 002.482-6.041h-4.22a13.852 13.852 0 01-2.255 4.134 21.02 21.02 0 01-3.455 3.59c-.318-.258-.612-.52-.924-.796a20.008 20.008 0 003.388-3.467c-.911.159-1.896.3-2.941.416a41.785 41.785 0 01-3.058.226c-.293-.379-.575-.77-.85-1.168a44.653 44.653 0 003.785-.25 49.313 49.313 0 004.036-.612c.413-.65.758-1.34 1.027-2.06H.544c-.19-.392-.367-.796-.532-1.224L0 29.046z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.352 7.784h12.957a.611.611 0 00.612-.611V6.078a.611.611 0 00-.612-.611H14.352a.611.611 0 00-.612.611v1.083a.611.611 0 00.612.611v.012zm1.65 21.861V11.368a.678.678 0 01.68-.68h.85a.679.679 0 01.678.68v18.277h1.517V11.368a.678.678 0 01.678-.68h.85a.679.679 0 01.68.68v18.277h1.516V11.368a.679.679 0 01.678-.68h.875a.679.679 0 01.679.68v18.277h1.956V10.17a1.442 1.442 0 00-1.467-1.425H15.489a1.443 1.443 0 00-1.443 1.443v19.476l1.957-.018zM29.989 0a22.586 22.586 0 013.448 1.92H8.225A22.29 22.29 0 0111.673 0h18.315zM13.25 5.589v.202a2.954 2.954 0 01-.777 2.005 2.63 2.63 0 01-1.956.875 2.623 2.623 0 01-1.951-.874A2.947 2.947 0 017.79 5.79a2.966 2.966 0 01.777-2.006 2.648 2.648 0 011.95-.874h20.944a2.648 2.648 0 011.957.874c.5.548.778 1.264.776 2.006a2.947 2.947 0 01-.776 2.005 2.629 2.629 0 01-1.957.875 2.624 2.624 0 01-1.95-.874 2.917 2.917 0 01-.777-2.006v-.202h1.932v.202c-.005.261.089.514.263.71a.727.727 0 00.544.25.74.74 0 00.55-.25c.172-.197.266-.45.264-.71a1.064 1.064 0 00-.263-.71.758.758 0 00-.55-.25H10.53a.759.759 0 00-.544.25 1.064 1.064 0 00-.263.71c-.003.26.091.513.263.71a.734.734 0 00.544.25.74.74 0 00.55-.25c.172-.197.265-.45.263-.71v-.208l1.908.006z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_32",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H390.938V43H0z"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/variables/wideformatprintercostsVariables.module.scss
var wideformatprintercostsVariables_module = __webpack_require__(75321);
var wideformatprintercostsVariables_module_default = /*#__PURE__*/__webpack_require__.n(wideformatprintercostsVariables_module);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/bestrounduplawyersWrapper.tsx










const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
function BestRoundupLawyersWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Roundup",
                    domain: "BestRoundupLawyers.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Roundup",
                    domain: "BestRoundupLawyers.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        textColor: (wideformatprintercostsVariables_module_default()).orange,
                        iconColor: (wideformatprintercostsVariables_module_default()).blue,
                        slogan: `find the best roundup lawyers ${region ? `in ${region}` : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BestZantaclawyersLogo, {})
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 75321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue":"#168fce","pink":"#e2048c","hoverBg":"#fef8fb"};

/***/ })

}]);